export class RepresentationPair {
  representative: string;
  representativeActingAs: string;
  actingOnBehalfOfVendorName: string;
}
